import React, { useContext, useEffect, useState } from "react";
import { ProfileWithSubscription } from "@glamcorner/gc-types/generated/types";
import { ServerGateway } from "../../services/ServerGateway";

export interface ProfileContextValue {
  profile: ProfileWithSubscription | null;
}

export const ProfileContext = React.createContext<ProfileContextValue>({
  profile: null,
});

// Lifted from subscription app.
// These generic providers should be extracted and shared. Session provider especially
export const ProfileProvider: React.FC = ({ children }) => {
  const [profile, setProfile] = useState<ProfileWithSubscription | null>(null);

  const serverGateway = new ServerGateway();

  const loadProfile = async (): Promise<void> => {
    const response = await serverGateway.getCustomerProfile();
    if (response) {
      setProfile(response);
    }
  };

  useEffect(() => {
    loadProfile();
  }, []);

  const contextValue: ProfileContextValue = {
    profile,
  };
  return <ProfileContext.Provider value={contextValue}>{children}</ProfileContext.Provider>;
};

export const useProfile = () => useContext(ProfileContext);
